import axios from 'axios'

const API = axios.create({ baseURL: 'https://oyeeah.herokuapp.com/' })

API.interceptors.request.use((req) => {
  if (localStorage.getItem('profile')) {
    req.headers.Authorization = `Bearer ${
      JSON.parse(localStorage.getItem('profile')).token
    }`
  }
  return req
})
export const fetchPost = (id) => API.get(`/posts/${id}`)
export const fetchPosts = () => API.get('/posts')
export const fetchPostsBySearch = (searchQuery) =>
  API.get(`/posts/directory/search?searchQuery=${searchQuery.search || 'none'}`)
export const createPost = (newPost) => API.post('/posts', newPost)
export const updatePost = (id, updatedPost) =>
  API.patch(`/posts/${id}`, updatedPost)
export const deletePost = (id) => API.delete(`/posts/${id}`)

export const signIn = (formData) => API.post('/user/signin', formData)
export const signUp = (formData) => API.post('/user/signup', formData)

export const fetchUser = (username) => API.get(`/user/${username}`)
export const fetchUsers = () => API.get('/users')
export const updateUser = (username, updatedUser) =>
  API.patch(`/user/${username}`, updatedUser)
